import { Alert, Button } from 'antd';
import classNames from 'classnames';
import { compose, equals, find, isEmpty, map, path, prop, propEq, propOr } from 'ramda';
import { notEqual } from 'ramda-adjunct';
import React, { useState } from 'react';
import { Components } from '@fasstech/flexiget';
import { useDocumentContext } from '../../../../context/Document';
import WidgetsForm from './documentFormTabs/createTab/WidgetsForm';

const DocumentContents = ({
  type,
  content,
  addWidget,
  addRowWidget,
  removeWidget,
  updateWidget,
  addWidgetRule,
  removeWidgetRule,
  updateWidgetRule,
  getRulesAreValid,
  getConditionsAreValid,
  dataItemPrefix,
  moveRowWidget,
  sectionIndex,
  title,
  hasSectionBreakPage,
  addManualBreakPageRule,
  removeManualBreakPageRule,
  updateManualBreakPageRule,
  setIsOpenCreateWidgetModal,
  userCanEdit,
  isEdit
}) => {
  const {
    updatePaddingRow,
    loading,
    updateManualBreakPage,
    previewLoading,
    values,
    globalVariables,
    widgets
  } = useDocumentContext();

  const getWidgetVariables = widgetId => compose(
    propOr([], 'variables'),
    find(propEq(widgetId, 'id'))
  )(widgets);

  const globalVariablesNames = map(prop('name'), globalVariables);
  const [isDynamicTableInSection, setIsDynamicTableInSection] = useState(false);

  const displayAddBtn = notEqual('widgets', type) && isEmpty(path(['pages', sectionIndex, type], values));

  return (
    <div className={classNames('section-container', { 'mt-2 mb-2': equals('widgets', type) })}>
      <div className="text-base text-flexi-text font-medium">{title}</div>
      {displayAddBtn ? (
        userCanEdit && (
          <Components.Tooltip title={`Ajouter ${equals('header', type) ? 'une en-tête' : 'un pied de page'}`} className="ml-3 mt-3 w-fit">
            <Button
              size="small"
              onClick={addWidget(sectionIndex, type)}
              disabled={loading || previewLoading}
              className={classNames('!rounded-full', equals('header', type) ? 'add-header-btn' : 'add-footer-btn')}
            >
              +
            </Button>
          </Components.Tooltip>
        )
      ) : (
        <div className="scrollbar max-h-450px pt-3 overflow-y-auto">
          {isEdit && userCanEdit && isDynamicTableInSection && !hasSectionBreakPage && (
            <Alert
              type="warning"
              showIcon
              closable
              description="Le tableau dynamique peut dépasser de la page, pensez à activer le saut de page automatique."
            />
          )}
          <WidgetsForm
            widgets={content}
            type={equals('widgets', type) ? 'content' : type}
            getRulesAreValid={getRulesAreValid}
            getConditionsAreValid={getConditionsAreValid}
            getWidgetVariables={getWidgetVariables}
            itemPathPrefix={[...dataItemPrefix, 'pages', sectionIndex, type]}
            addRowWidget={addRowWidget(sectionIndex, type)}
            addWidget={addWidget(sectionIndex, type)}
            updateManualBreakPage={updateManualBreakPage(sectionIndex)}
            updatePaddingRow={updatePaddingRow(sectionIndex, type)}
            removeWidget={removeWidget(sectionIndex, type)}
            moveRowWidget={moveRowWidget(sectionIndex, type)}
            updateWidget={updateWidget(globalVariablesNames, sectionIndex, type)}
            addWidgetRule={addWidgetRule(sectionIndex, type)}
            removeWidgetRule={removeWidgetRule(sectionIndex, type)}
            updateWidgetRule={updateWidgetRule(sectionIndex, type)}
            disabled={loading || previewLoading}
            setIsDynamicTableInSection={setIsDynamicTableInSection}
            hasSectionBreakPage={hasSectionBreakPage}
            addManualBreakPageRule={addManualBreakPageRule(sectionIndex)}
            removeManualBreakPageRule={removeManualBreakPageRule(sectionIndex)}
            updateManualBreakPageRule={updateManualBreakPageRule(sectionIndex)}
            setIsOpenCreateWidgetModal={setIsOpenCreateWidgetModal}
            userCanEdit={userCanEdit}
          />
          {userCanEdit && (
            <Components.Tooltip title="Ajouter une ligne" className="ml-3 w-fit">
              <Button
                size="small"
                onClick={addWidget(sectionIndex, type)}
                disabled={loading || previewLoading}
                className="!rounded-full"
              >
                +
              </Button>
            </Components.Tooltip>
          )}
        </div>
      )}
    </div>
  );
};

export default DocumentContents;
